import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'libero-blog-pagination',
  templateUrl: './blog-pagination.component.html',
  styleUrls: ['./blog-pagination.component.scss'],
  standalone: false
})
export class BlogPaginationComponent implements OnChanges {
  @Input() public articlesTotal?: number;
  @Input() public articlesSizePerPage?: number;
  @Output() public paginationBtnClick = new EventEmitter<number>();
  @Input() public activePage = 1;

  private pagesMax = 1

  public ngOnChanges(): void {
    if (this.articlesTotal && this.articlesSizePerPage) {
      this.pagesMax = Math.ceil(this.articlesTotal / this.articlesSizePerPage);
    }
  }

  public get pagesArr(): number[] {
    return Array.from({length: this.pagesMax}, (_, i) => i + 1)
  }

  public gotToPage(nextPage: number): void  {
    this.paginationBtnClick.emit(nextPage);
    this.activePage = nextPage;
  }

}
